module.exports = __webpack_public_path__ + "img/fossilImg3.3aaaf4f7.jpg";